<template>
  <div class="change-password">
    <MobileNav :page_title="nav_title"></MobileNav>
    <div class="background-image">
      <ChangePasswordComponent
        class="change-password-component"
      ></ChangePasswordComponent>
    </div>
  </div>
</template>

<script>
import ChangePasswordComponent from "@/components/ChangePasswordComponent.vue";
import MobileNav from "@/components/MobileNav.vue";
export default {
  name: "ChangePassword",

  components: {
    ChangePasswordComponent,
    MobileNav,
  },

  data() {
    return {
      nav_title: "Change Password",
    };
  },
  validations: {},

  watch: {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.change-password {
  .background-image {
    background-image: url("../assets/images/login/mobilebg.png");
    height: 75vh;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
    padding-top: 25vh;
  }
  .change-password-component {
    width: 350px;
    margin: 0 auto;
  }
  @media screen and (max-width: 1000px) {
    .background-image {
      padding-top: 18vh;
    }
  }
  @media screen and (max-width: 400px) {
    .change-password-component {
      width: 95%;
    }
  }
}
</style>
<style lang="scss">
.change-password {
  // .el-collapse-item__header.is-active,
  // .collapse-item__arrow,
  // .el-collapse-item__arrow.is-active {
  //   display: none !important;
  // }
}
</style>
